import { SvgIconProps } from '@material-ui/core';
import { handlePriceCheck } from 'src/price-check/business-logic/handle-price-check';
import { handleReturnItem } from 'src/return-item/business-logic/handle-return-item';
import { exitReturnMode } from 'src/return-services-display/business-logic/return-transaction';
import {
  exemptTransactionTax,
  exemptLineTax,
} from 'src/tax-exemption/business-logic/tax-exemption';
import { handleVoidByCode } from 'src/void-by-code/business-logic/handle-void-by-code';
import { ButtonRestrictionType } from '../common/enumerations/button-restriction-type';
import { voidAllCouponsButtonAction } from '../coupons/business-logic/void-coupon-line-item';
import { initiateDepartmentSale } from '../department-sale/business-logic/handle-department-sale';
import { openCashDrawer } from '../devices/cash-drawer-operations';
import { removeCustomerHandler } from '../home-page/business-logic/remove-loyalty-customer';
import { saveTransaction } from '../home-page/business-logic/save-transaction';
import { voidActiveTransaction } from '../home-page/business-logic/void-transaction';
import { displayInterventions } from '../interventions/business-logic/get-interventions';
import { initializePreSalePriceOverride } from '../pre-sale-price-override/business-logic/handle-pre-sale-price-override';
import { pushScanAndGoModal } from '../search-scan-and-go/business-logic/push-scan-and-go-modal';
import {
  DepartmentSaleIcon,
  PriceCheckIcon,
  PriceOverrideIcon,
  ReloadItemIcon,
  RemoveCustomerIcon,
  RepeatIcon,
  ReprintReceiptIcon,
  ReturnItemIcon,
  SaveTransactionIcon,
  ScanAndGoIcon,
  TaxExemptionIcon,
  VoidCodeIcon,
  VoucherIcon,
  TenderExchangeIcon,
  BalanceInquiryIcon,
  SaleModeIcon,
  DepartmentReturnIcon,
  OwnBagIcon,
} from './components/sidebar-icons';
import { initializeMergeTransaction } from '../merge-transaction/business-logic/merge-transaction-handler';
import { handleBalanceInquiry } from '../balance-inquiry/business-logic/handle-balance-inquiry';
import { handleReprintReceiptClick } from 'src/reprint-receipt/business-logic/handle-reprint-receipt';
import { handleVoucherBarcodeCommand } from 'src/barcode/business-logic/handle-voucher-barcode-command';
import { handleCustomerLoyaltySearch } from 'src/customer-loyalty/business-logic/handle-customer-loyalty-search';
import { showReloadItem } from 'src/reload-item/reload-item';
import { handleTenderExchange } from 'src/tender-exchange/business-logic/handle-tender-exchange';
import { handleRepeat } from 'src/home-page/business-logic/repeat-item';
import { IButtonParameter } from 'src/common/interfaces/dtos/ICommandsGroup';
import { pushRecallTransactionScreen } from 'src/search-transactions/business-logic/push-recall-transaction-screen';
import { handleOwnBag } from 'src/own-bag/business-logic/handle-own-bag';

export interface MenuItem {
  key: string;
  icon?: (props: SvgIconProps) => JSX.Element;
  className?: string;
  handleClick?: (parameters?: IButtonParameter[]) => void;
  appliesTo?: ButtonRestrictionType[];
}

export const getSidebarButtons = (): MenuItem[] => {
  return [
    {
      key: 'RetrieveSelfScanTransactionCommand',
      handleClick: pushScanAndGoModal,
      appliesTo: [ButtonRestrictionType.InactiveTransaction],
      icon: ScanAndGoIcon,
    },
    {
      key: 'ReInitDevicesCommand',
    },
    {
      key: 'DeclarationCommand',
    },
    {
      key: 'TenderPickupCommand',
    },
    {
      key: 'DepartmentSaleCommand',
      handleClick: initiateDepartmentSale,
      appliesTo: [ButtonRestrictionType.NotRecall, ButtonRestrictionType.All],
      icon: DepartmentSaleIcon,
    },
    {
      key: 'ChangePasswordCommand',
    },
    {
      key: 'ResumeTransactionCommand',
      handleClick: pushRecallTransactionScreen,
      appliesTo: [ButtonRestrictionType.InactiveTransaction],
      icon: SaveTransactionIcon,
    },
    {
      key: 'BlindPickupCommand',
    },
    {
      key: 'TillClosingCommand',
    },
    {
      key: 'WicTransactionCommand',
    },
    {
      key: 'WicCvvTransactionCommand',
    },
    {
      key: 'RePrintTransactionCommand',
    },
    {
      key: 'EnhancedRePrintTransactionCommand',
    },
    {
      key: 'AddLoanCommand',
    },
    {
      key: 'OpenCashDrawerCommand',
      handleClick: openCashDrawer,
      appliesTo: [ButtonRestrictionType.HasCashDrawer],
    },
    {
      key: 'PaidInCommand',
    },
    {
      key: 'PaidOutCommand',
    },
    {
      key: 'ExemptTransactionTaxesCommand',
    },
    {
      key: 'PrintCertificateCommand',
    },
    {
      key: 'TransactionBasedReturnCommand',
    },
    {
      key: 'ReturnAllTransactionCommand',
    },
    {
      key: 'ReturnTransactionBySerialCommand',
    },
    {
      key: 'CustomerDepositCommand',
    },
    {
      key: 'BottleDepositCommand',
    },
    {
      key: 'CashierBarcodeCommand',
    },
    {
      key: 'ReprintCommand',
      appliesTo: [ButtonRestrictionType.All],
      handleClick: handleReprintReceiptClick,
      icon: ReprintReceiptIcon,
    },
    {
      key: 'GoToReprintCommand',
    },
    {
      key: 'PrintXReportCommand',
    },
    {
      //TODO: No matching description found in translation.json
      key: 'ReprintTransactionMainCommands',
    },
    {
      //TODO: No matching description found in translation.json
      key: 'ReprintTransactionAdditionalCommands',
    },
    {
      key: 'HardwareErrorsListCommand',
    },
    {
      key: 'SearchCommand',
    },
    {
      key: 'GiftReceiptSelectionCommand',
    },
    {
      key: 'PriceQueryCommand',
      appliesTo: [ButtonRestrictionType.All],
      handleClick: handlePriceCheck,
      icon: PriceCheckIcon,
    },
    {
      key: 'LockCommand',
    },
    {
      key: 'AlertTemplateLookupCommand',
    },
    {
      key: 'ManualWeightCommand',
    },
    {
      key: 'SignOffCommand',
    },
    {
      key: 'PreSalePriceOverrideCommand',
      handleClick: initializePreSalePriceOverride,
      appliesTo: [ButtonRestrictionType.All],
      icon: PriceOverrideIcon,
    },
    {
      key: 'TopUpCommand',
      icon: ReloadItemIcon,
      handleClick: () => showReloadItem(),
      appliesTo: [ButtonRestrictionType.All],
    },
    {
      key: 'OnlineItemBalanceQueryCommand',
      icon: BalanceInquiryIcon,
      handleClick: () => handleBalanceInquiry(),
      appliesTo: [ButtonRestrictionType.All, ButtonRestrictionType.NotProcessing],
    },
    {
      key: 'EatInCommand',
    },
    {
      key: 'SetGetItemToReturnStateCommand',
      handleClick: handleReturnItem,
      appliesTo: [ButtonRestrictionType.SaleModeFromReturnMode],
      icon: ReturnItemIcon,
    },
    {
      key: 'TaxDiscountCommand',
    },
    {
      key: 'InterventionListCommand',
      handleClick: displayInterventions,
      appliesTo: [ButtonRestrictionType.ActiveTransaction],
    },
    {
      key: 'VoidTransactionCommand',
      handleClick: voidActiveTransaction,
      appliesTo: [ButtonRestrictionType.ActiveTransaction],
      icon: VoidCodeIcon,
    },
    {
      key: 'ForceFullRescan',
    },
    {
      key: 'SuspendTransactionCommand',
      handleClick: saveTransaction,
      appliesTo: [ButtonRestrictionType.ActiveTransaction],
      icon: SaveTransactionIcon,
    },
    {
      key: 'SetCancelItemStateCommand',
      handleClick: handleVoidByCode,
      appliesTo: [ButtonRestrictionType.HasActiveProductLines],
      icon: VoidCodeIcon,
    },
    {
      key: 'RepeatCommand',
      icon: RepeatIcon,
      handleClick: handleRepeat,
      appliesTo: [ButtonRestrictionType.NotTender],
    },
    {
      key: 'ManualCouponCommand',
    },
    {
      key: 'RemoveCustomerFromTransactionCommand',
      handleClick: removeCustomerHandler,
      appliesTo: [ButtonRestrictionType.HasCustomer],
      icon: RemoveCustomerIcon,
    },
    {
      key: 'ApplyTransactionTaxExemptionCommand',
      handleClick: exemptTransactionTax,
      appliesTo: [ButtonRestrictionType.ActiveTransaction],
      icon: TaxExemptionIcon,
    },
    {
      key: 'ApplyItemTaxExemptionCommand',
      handleClick: exemptLineTax,
      appliesTo: [ButtonRestrictionType.ActiveTransaction, ButtonRestrictionType.TaxExemption],
      icon: TaxExemptionIcon,
    },
    {
      key: 'WhyDidntGetCommand',
    },
    {
      key: 'VoidAllCouponsCommand',
      handleClick: voidAllCouponsButtonAction,
      appliesTo: [ButtonRestrictionType.HasCoupons],
    },
    {
      key: 'ManualPromotionCommand',
    },
    {
      key: 'TaxesReversalCommand',
    },
    {
      key: 'ManualVolumeCommand',
    },
    {
      key: 'CustomerDataCommand',
    },
    {
      key: 'SearchCustomerCommand',
      handleClick: handleCustomerLoyaltySearch,
      appliesTo: [ButtonRestrictionType.All],
    },
    {
      key: 'GoToSaleModeCommand',
      handleClick: exitReturnMode,
      appliesTo: [ButtonRestrictionType.SaleModeFromReturnMode],
      icon: SaleModeIcon,
    },
    {
      key: 'DepartmentReturnCommand',
      handleClick: initiateDepartmentSale,
      appliesTo: [ButtonRestrictionType.NotRecall],
      icon: DepartmentReturnIcon,
    },
    {
      key: 'MergeTransactionCommand',
      handleClick: initializeMergeTransaction,
      appliesTo: [ButtonRestrictionType.All],
    },
    {
      key: 'VoucherBarcodeCommand',
      handleClick: handleVoucherBarcodeCommand,
      appliesTo: [ButtonRestrictionType.All],
      icon: VoucherIcon,
    },
    {
      key: 'TenderExchangeCommand',
      handleClick: handleTenderExchange,
      appliesTo: [ButtonRestrictionType.InactiveTransaction],
      icon: TenderExchangeIcon,
    },
    {
      key: 'OwnBagSelectionCommand',
      handleClick: handleOwnBag,
      appliesTo: [ButtonRestrictionType.OwnBagEnabled],
      icon: OwnBagIcon,
    },
  ];
};
